var _toConsumableArray = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('./data/keys'),
    translations = _require.translations,
    ignore = _require.ignore,
    stickyTranslations = _require.stickyTranslations,
    idKeysTranslation = _require.idKeysTranslation,
    idValuesTranslation = _require.idValuesTranslation,
    mp4ValidSamples = _require.mp4ValidSamples;

var deduceHeaders = require('./utils/deduceHeaders');

var hero7Labelling = require('./utils/hero7Labelling');

var breathe = require('./utils/breathe'); //Compare equality of values, including objects


function deepEqual(a, b) {
  if (typeof a !== 'object' || typeof b !== 'object' || a == null || b == null) return a === b;
  if (Object.keys(a).length !== Object.keys(b).length) return false;

  for (var i = 0; i < Object.keys(a).length; i++) {
    if (!deepEqual(a[Object.keys(a)[i]], b[Object.keys(a)[i]])) return false;
  }

  return true;
} //Merges all samples of every device under the same key


function mergeStreams(_x, _x2) {
  return _mergeStreams.apply(this, arguments);
}

function _mergeStreams() {
  _mergeStreams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(klv, _ref) {
    var repeatHeaders, repeatSticky, mp4header, result, stickies, _iterator, _step, d, i, s, key;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            repeatHeaders = _ref.repeatHeaders, repeatSticky = _ref.repeatSticky, mp4header = _ref.mp4header;
            //Will return a list of streams for a device
            result = {
              streams: {}
            }; //Remember stickies per device and stream, to avoid looping every time

            stickies = {};
            _iterator = _createForOfIteratorHelper(klv.DEVC || []);
            _context6.prev = 4;

            _iterator.s();

          case 6:
            if ((_step = _iterator.n()).done) {
              _context6.next = 35;
              break;
            }

            d = _step.value;

            if (!(d != null)) {
              _context6.next = 29;
              break;
            }

            stickies[d['device name']] = stickies[d['device name']] || {};
            _context6.prev = 10;
            i = 0;

          case 12:
            if (!(i < d.STRM.length)) {
              _context6.next = 25;
              break;
            }

            _context6.next = 15;
            return breathe();

          case 15:
            s = d.STRM[i] || {}; //We will store the main samples of the nest. Except for STNM, which looks to be an error with the data

            if (!((!mp4header || mp4ValidSamples.includes(s.interpretSamples)) && s.interpretSamples && s.interpretSamples !== 'STNM')) {
              _context6.next = 20;
              break;
            }

            return _context6.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              var fourCC, samples, multiple, sticky, description, key, _i, _key, workOnHeaders, completeSample;

              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      fourCC = s.interpretSamples; //Initialise stickies

                      stickies[d['device name']][fourCC] = stickies[d['device name']][fourCC] || {}; //Get the array of samples

                      samples = s[fourCC]; //Delete the samples from the original to avoid duplication

                      delete s[fourCC];
                      delete s.interpretSamples; //Remember if will need to separate multiple samples

                      multiple = s.multi;
                      delete s.multi;

                      if (!(samples && samples.length)) {
                        _context5.next = 23;
                        break;
                      }

                      sticky = {};
                      description = {
                        name: fourCC
                      }; //Loop the rest of values

                      for (key in s) {
                        //Translate keys to human when necessary
                        if (translations[key]) description[translations[key]] = s[key]; //Make the rest sticky, unless we want to ignore them
                        else if (!ignore.includes(key)) sticky[stickyTranslations[key] || key] = s[key];
                      } //Remember previous sticky values, that's why they're sticky


                      sticky = _objectSpread(_objectSpread({}, stickies[d['device name']][fourCC]), sticky); //If repeatSticky, add the sticky values to every sample

                      if (repeatSticky) {
                        for (_i = 0; _i < samples.length; _i++) {
                          samples[_i] = _objectSpread(_objectSpread({}, samples[_i] || {}), sticky);
                        }
                      } //If have both samples and stickies
                      else if (Object.keys(sticky).length && samples.length) {
                        for (_key in sticky) {
                          //Save sticky values that have changed, discard the rest
                          if (!deepEqual(sticky[_key], stickies[d['device name']][fourCC][_key])) {
                            samples[0].sticky = samples[0].sticky || {};
                            samples[0].sticky[_key] = sticky[_key];
                          }
                        }
                      } //Remember the new sticky values


                      stickies[d['device name']][fourCC] = _objectSpread(_objectSpread({}, stickies[d['device name']][fourCC]), sticky); //Use name and units to describe every sample

                      workOnHeaders = /*#__PURE__*/function () {
                        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(samples, desc) {
                          var description, headers, _loop, _i2;

                          return _regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  description = JSON.parse(JSON.stringify(desc));
                                  headers = deduceHeaders(description); //Add the descriptions and values to samples

                                  _loop = function _loop(_i2) {
                                    //If no available description, use numbers
                                    var ss = samples[_i2] || {};

                                    if (Array.isArray(ss.value)) {
                                      ss.value.forEach(function (v, i) {
                                        return ss[headers[i] || "(".concat(i, ")")] = v;
                                      });
                                    } else if (headers[0]) ss[headers[0]] = ss.value; //Delete value key if we solved the situation


                                    if (headers.length) delete ss.value;
                                    samples[_i2] = ss;
                                  };

                                  for (_i2 = 0; _i2 < samples.length; _i2++) {
                                    _loop(_i2);
                                  } //Delete names and units, not needed any more


                                  delete description.units;
                                  delete description.name;
                                  return _context.abrupt("return", {
                                    samples: samples,
                                    description: description
                                  });

                                case 7:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        }));

                        return function workOnHeaders(_x3, _x4) {
                          return _ref2.apply(this, arguments);
                        };
                      }(); //Simplify Hero7 Labelling style


                      description.name = hero7Labelling(description.name); //This bit saved as function for more than one condition to use it

                      completeSample = /*#__PURE__*/function () {
                        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
                          var _result$streams$fourC;

                          var samples, description, newResults;
                          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  samples = _ref3.samples, description = _ref3.description;

                                  if (!repeatHeaders) {
                                    _context2.next = 7;
                                    break;
                                  }

                                  _context2.next = 4;
                                  return workOnHeaders(samples, description);

                                case 4:
                                  newResults = _context2.sent;
                                  samples = newResults.samples;
                                  description = newResults.description;

                                case 7:
                                  //Add samples to stream entry
                                  if (result.streams[fourCC]) (_result$streams$fourC = result.streams[fourCC].samples).push.apply(_result$streams$fourC, _toConsumableArray(samples));else result.streams[fourCC] = _objectSpread({
                                    samples: samples
                                  }, description);

                                case 8:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2);
                        }));

                        return function completeSample(_x5) {
                          return _ref4.apply(this, arguments);
                        };
                      }(); //Separate multiple samples if needed


                      if (!multiple) {
                        _context5.next = 21;
                        break;
                      }

                      return _context5.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                        var newSamples, idKey, parts, _loop3, _i4, _key2, _result$streams$sampl, desc, newResults;

                        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                          while (1) {
                            switch (_context4.prev = _context4.next) {
                              case 0:
                                //We are assuming the first value is the ID, as it happens with FACES, this might be completely wrong
                                newSamples = {}; //Dummy id key if none is found

                                idKey = 'id';

                                if (description.name) {
                                  //Remove ID from description if present
                                  parts = description.name.match(/\((\w+),?(.*)\)$/i);

                                  if (parts) {
                                    //Save id key for later
                                    idKey = idKeysTranslation(parts[1]);
                                  }
                                }

                                if (!(samples[0].value[0] && samples[0].value[0].length === 2)) {
                                  _context4.next = 7;
                                  break;
                                }

                                return _context4.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                                  var headers, newSamples, _loop2, _i3;

                                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                                    while (1) {
                                      switch (_context3.prev = _context3.next) {
                                        case 0:
                                          //keep everything in 1 stream, just label it
                                          headers = [];
                                          newSamples = []; //Grab the id of each substream, save it for the description, and save the second value as the only value

                                          _loop2 = function _loop2(_i3) {
                                            var ss = samples[_i3] || {}; //Loop inner samples

                                            var newSample = _objectSpread(_objectSpread({}, ss), {}, {
                                              value: []
                                            });

                                            (ss.value || []).forEach(function (v, x) {
                                              if (v != null && Array.isArray(v)) {
                                                headers[x] = idValuesTranslation(v[0], idKey);
                                                newSample.value.push(v[1]);
                                              }
                                            });
                                            newSamples.push(newSample);
                                          };

                                          for (_i3 = 0; _i3 < samples.length; _i3++) {
                                            _loop2(_i3);
                                          }

                                          if (parts) {
                                            //Add previously known units to description
                                            description.name = description.name.replace(/\((\w+),?(.*)\)$/i, " | ".concat(idKey));
                                            description.units = parts[2].split(',').map(function (p) {
                                              return p.trim();
                                            });
                                          } //Add new keys


                                          description.name += " (".concat(headers.join(','), ")");
                                          _context3.next = 8;
                                          return completeSample({
                                            samples: newSamples,
                                            description: description
                                          });

                                        case 8:
                                        case "end":
                                          return _context3.stop();
                                      }
                                    }
                                  }, _callee3);
                                })(), "t0", 5);

                              case 5:
                                _context4.next = 24;
                                break;

                              case 7:
                                //Split stream in substreams
                                if (parts) description.name = description.name.replace(/\((\w+),?(.*)\)$/i, "(".concat(parts[2], ")"));

                                _loop3 = function _loop3(_i4) {
                                  var ss = samples[_i4] || {}; //Loop inner samples

                                  (ss.value || []).forEach(function (v) {
                                    if (v != null && Array.isArray(v)) {
                                      var id = v[0]; //Assign first value as ID if not done

                                      if (!newSamples[id]) newSamples[id] = [];
                                      var thisSample = {}; //Copy all keys except the value

                                      Object.keys(ss).forEach(function (k) {
                                        if (k !== 'value') thisSample[k] = ss[k];
                                      }); //And copy the rest

                                      thisSample.value = v.slice(1); //And simplify single values

                                      if (Array.isArray(thisSample.value) && thisSample.value.length === 1) thisSample.value = thisSample.value[0]; //Save

                                      newSamples[id].push(thisSample);
                                    }
                                  });
                                };

                                for (_i4 = 0; _i4 < samples.length; _i4++) {
                                  _loop3(_i4);
                                }

                                _context4.t1 = _regeneratorRuntime.keys(newSamples);

                              case 11:
                                if ((_context4.t2 = _context4.t1()).done) {
                                  _context4.next = 24;
                                  break;
                                }

                                _key2 = _context4.t2.value;
                                //Add id
                                description.subStreamName = "".concat(idKey, ":").concat(idValuesTranslation(_key2, idKey));
                                desc = description;

                                if (!repeatHeaders) {
                                  _context4.next = 21;
                                  break;
                                }

                                _context4.next = 18;
                                return workOnHeaders(newSamples[_key2], description);

                              case 18:
                                newResults = _context4.sent;
                                newSamples[_key2] = newResults.samples;
                                desc = newResults.description;

                              case 21:
                                //Add samples to stream entry
                                if (result.streams[fourCC + _key2]) (_result$streams$sampl = result.streams[fourCC + _key2].samples).push.apply(_result$streams$sampl, _toConsumableArray(newSamples[_key2]));else result.streams[fourCC + _key2] = _objectSpread({
                                  samples: newSamples[_key2]
                                }, desc);
                                _context4.next = 11;
                                break;

                              case 24:
                              case "end":
                                return _context4.stop();
                            }
                          }
                        }, _callee4);
                      })(), "t0", 19);

                    case 19:
                      _context5.next = 23;
                      break;

                    case 21:
                      _context5.next = 23;
                      return completeSample({
                        samples: samples,
                        description: description
                      });

                    case 23:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            })(), "t0", 18);

          case 18:
            _context6.next = 22;
            break;

          case 20:
            if (s.interpretSamples) delete s.interpretSamples;
            result.streams["Data ".concat(i)] = JSON.parse(JSON.stringify(d.STRM));

          case 22:
            i++;
            _context6.next = 12;
            break;

          case 25:
            _context6.next = 29;
            break;

          case 27:
            _context6.prev = 27;
            _context6.t1 = _context6["catch"](10);

          case 29:
            //Delete used data
            delete d.DVID;
            delete d.interpretSamples;
            delete d.STRM; //Translate top level keys

            for (key in d) {
              if (translations[key]) result[translations[key]] = d[key];else result[key] = d[key];
            }

          case 33:
            _context6.next = 6;
            break;

          case 35:
            _context6.next = 40;
            break;

          case 37:
            _context6.prev = 37;
            _context6.t2 = _context6["catch"](4);

            _iterator.e(_context6.t2);

          case 40:
            _context6.prev = 40;

            _iterator.f();

            return _context6.finish(40);

          case 43:
            return _context6.abrupt("return", result);

          case 44:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[4, 37, 40, 43], [10, 27]]);
  }));
  return _mergeStreams.apply(this, arguments);
}

module.exports = mergeStreams;